<template>
  <v-autocomplete
      v-model="options"
      :items="storeList"
      :label="label"
      :rules="rules"
      item-text="shopName"
      item-value="shopId"
      :clearable="!readonly"
      outlined
      dense
      :readonly="readonly"
  ></v-autocomplete>
</template>

<script>
import {default as ContractApi} from "@/api/erp/contract/ContractApi";
import Permission, {default as PermissionApi} from "@/api/smp/auth/Permission";

export default {
  name: "StoreSelect",
  data(){
    return {
      storeList:[],
    }
  },
  props: {
    value: {
      type: [Number,String],
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default :''
    },
    rules:{
      type: Array
    }
  },
  model: {
    prop: 'value',
    event: 'modify',
  },
  created() {
    this.listStore();
  },
  computed: {
    options: {
      get: function () {
        return this.value //将props中的typeId值赋给value
      },
      set: function (val) {
        this.$emit('modify', val) //通过$emit触发父组件
      },
    },
  },
  methods:{
    listStore(){
      let me = this;
      Permission.queryShopPriviledge().then(resp=>{
        PermissionApi.handleResponse(resp, me, function (data){
          me.storeList = data.shopPriviledges;
        })
      })

      // ContractApi.listStore().then(data=>{
      //     me.storeList = data;
      // })
    },
  }
}
</script>

<style scoped>

</style>